import { createApp } from 'vue';

import router from '@/system_modules/router';
// import store from '@/system_modules/store';

import { createPinia } from 'pinia';

// import { createHead } from "@vueuse/head";

import PrimeVue from 'primevue/config';
// import Lara from '@primevue/themes/lara';
// import Lara from '@/presets/lara';

import titleMixin from '@/system_modules/utils/titleMixin';

import App from '@/App';


const pinia = createPinia()

const ap = createApp(App)

// ap.use(store)
ap.use(pinia);
ap.use(router);
ap.use(PrimeVue, {
    // unstyled: true,
    // pt: Lara
    // Default theme configuration
    // theme: {
    //     preset: Lara,
    //     options: {
    //         prefix: 'p',
    //         darkModeSelector: 'system',
    //         cssLayer: false
    //     }
    // }
 });

// ap.use(createHead())

ap.mixin(titleMixin);


ap.config.globalProperties.$filters = {
    formatDate: value => {
        if( value ){
            let d = value.split('-');
            // let m = new Date(0,d[1],0).toLocaleDateString(store.state.lang, {month: 'short'});
            return `${d[2]}.${d[1]}.${d[0]}`;
        }
        else return value;
        // new Date(value).toLocaleDateString(store.state.lang, {
        //     year: 'numeric',
        //     month: 'short',
        //     day: 'numeric'
        // }),
    },

    replace: (str, txt1, txt2) => {
        if( str === undefined ) str = '';
        if( txt1 === undefined ) txt1 = '';
        if( txt2 === undefined ) txt2 = '';
        let re = RegExp(txt1, "mgi");
        return str.replace(re, txt2);
    },

    capitalize: str => str != '' ? (str.charAt(0).toUpperCase() + str.slice(1)) : '',

    stripTags: str => str != '' ? str.replace(/(<[^>]*>)*/gm, '') : '',

    formatCurrency: (value) => {
        if (value)
            return value.toLocaleString("az-AZ", {
                style: "currency",
                currency: "AZN",
            });
        return value;
    },
};


// ap.config.errorHandler = (err, instance, info) => {
//     return false;
//     // handle error, e.g. report to a service
// }

ap.mount('#app');
